module.exports = __webpack_public_path__ + "img/Fuchsreiterin.87105127.jpg";